import { ReactNode } from "react";

import { RichText } from "@/components/ui/v2/rich-text";
import { cn } from "@/lib/utils/cn";

type VacancyFieldProps = {
  label: string;
  text: string;
  fullHeight?: boolean;
  badge?: ReactNode;
};

export const VacancyField: React.FC<VacancyFieldProps> = ({
  label,
  text,
  fullHeight = false,
  badge,
}) => {
  return (
    <div className={cn("flex w-full flex-col gap-2", fullHeight && "flex-1")}>
      <div className="flex min-h-7 w-full items-center justify-between">
        <span className="text-base font-semibold text-foreground">{label}</span>
        {badge}
      </div>
      <div
        data-slot="panel"
        className={cn(
          "w-full rounded-lg border border-border bg-card p-3",
          fullHeight && "min-h-72 flex-1"
        )}
      >
        <RichText html={text || "N/A"} />
      </div>
    </div>
  );
};
